module.exports = __webpack_public_path__ + "static/img/sjtj_yellow.7d2cc8c1.svg";